import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function Services() {
  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero 섹션 */}
      <section className="relative pt-24 pb-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-block px-4 py-2 bg-orange-100 text-orange-700 text-sm font-medium rounded-full mb-6">
              OUR SERVICES
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              전문성과 혁신으로<br />
              최고의 서비스를 제공합니다
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              무역, 교육, 콘텐츠 제작 분야에서<br />
              차별화된 솔루션을 경험하세요
            </p>
          </div>
        </div>
      </section>

      {/* 무역 서비스 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div 
              className="h-96 bg-cover bg-center rounded-2xl order-2 lg:order-1"
              style={{
                backgroundImage: `url('https://public.readdy.ai/ai/img_res/18394ed4950bb92b1995cb6b2f05d988.jpg')`
              }}
            ></div>
            
            <div className="space-y-8 order-1 lg:order-2">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                  <i className="ri-ship-line text-2xl text-orange-600"></i>
                </div>
                <span className="px-4 py-2 bg-orange-100 text-orange-700 text-sm font-medium rounded-full">
                  TRADE
                </span>
              </div>
              
              <h2 className="text-4xl font-bold text-gray-900">
                한국–일본 무역
              </h2>
              
              <p className="text-xl text-gray-600 leading-relaxed">
                제조사와의 직접 거래를 통해 중간 단계를 생략하고, 
                품질 관리부터 출하까지 전 과정을 투명하게 관리합니다.
              </p>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">제조사 직접 거래</h4>
                    <p className="text-gray-600">중간 유통업체 없이 제조업체와 직접 거래하여 비용 절감과 품질 보장</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">전 과정 품질 관리</h4>
                    <p className="text-gray-600">제조 단계부터 출하까지 모든 과정을 직접 관리하고 모니터링</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">투명한 커뮤니케이션</h4>
                    <p className="text-gray-600">실시간 진행 상황 공유 및 투명한 정보 제공</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 교육 서비스 */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                  <i className="ri-book-open-line text-2xl text-orange-600"></i>
                </div>
                <span className="px-4 py-2 bg-orange-100 text-orange-700 text-sm font-medium rounded-full">
                  EDUCATION
                </span>
              </div>
              
              <h2 className="text-4xl font-bold text-gray-900">
                외국어 교육
              </h2>
              
              <p className="text-xl text-gray-600 leading-relaxed">
                영어와 일본어 전문 강사진이 제공하는 1:1 맞춤형 수업으로 
                실무에 바로 적용할 수 있는 언어 능력을 기릅니다.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white p-6 rounded-xl">
                  <h4 className="font-bold text-gray-900 mb-2">영어 수업</h4>
                  <p className="text-gray-600 text-sm">비즈니스 영어부터 일상 회화까지</p>
                </div>
                
                <div className="bg-white p-6 rounded-xl">
                  <h4 className="font-bold text-gray-900 mb-2">일본어 수업</h4>
                  <p className="text-gray-600 text-sm">기초부터 비즈니스 일본어까지</p>
                </div>
                
                <div className="bg-white p-6 rounded-xl">
                  <h4 className="font-bold text-gray-900 mb-2">1:1 맞춤형</h4>
                  <p className="text-gray-600 text-sm">개인별 수준에 맞춘 커리큘럼</p>
                </div>
                
                <div className="bg-white p-6 rounded-xl">
                  <h4 className="font-bold text-gray-900 mb-2">실용적 학습</h4>
                  <p className="text-gray-600 text-sm">실무에 바로 적용 가능한 내용</p>
                </div>
              </div>
            </div>
            
            <div 
              className="h-96 bg-cover bg-center rounded-2xl"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Online%20language%20education%20classroom%2C%20professional%20teacher%20with%20student%2C%20modern%20digital%20learning%20environment%2C%20Korean%20Japanese%20English%20education%2C%20interactive%20video%20call%20setup&width=800&height=600&seq=education-service-001&orientation=landscape')`
              }}
            ></div>
          </div>
        </div>
      </section>

      {/* 콘텐츠 제작 서비스 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div 
              className="h-96 bg-cover bg-center rounded-2xl order-2 lg:order-1"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20video%20content%20production%20studio%2C%20creative%20team%20filming%20educational%20content%2C%20professional%20video%20equipment%2C%20YouTube%20content%20creation%2C%20digital%20marketing%20production%20environment&width=800&height=600&seq=content-service-001&orientation=landscape')`
              }}
            ></div>
            
            <div className="space-y-8 order-1 lg:order-2">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                  <i className="ri-video-line text-2xl text-orange-600"></i>
                </div>
                <span className="px-4 py-2 bg-orange-100 text-orange-700 text-sm font-medium rounded-full">
                  CONTENTS
                </span>
              </div>
              
              <h2 className="text-4xl font-bold text-gray-900">
                콘텐츠 제작
              </h2>
              
              <p className="text-xl text-gray-600 leading-relaxed">
                교육 목적과 브랜드 신뢰도 향상을 위한 고품질 콘텐츠를 
                기획부터 제작까지 원스톱으로 제공합니다.
              </p>
              
              <div className="space-y-6">
                <div className="border-l-4 border-orange-500 pl-6">
                  <h4 className="font-bold text-gray-900 mb-2">교육 콘텐츠</h4>
                  <p className="text-gray-600">외국어 학습을 위한 유튜브 및 숏폼 콘텐츠 제작</p>
                </div>
                
                <div className="border-l-4 border-orange-500 pl-6">
                  <h4 className="font-bold text-gray-900 mb-2">브랜드 콘텐츠</h4>
                  <p className="text-gray-600">기업 신뢰도 향상을 위한 브랜드 스토리 콘텐츠</p>
                </div>
                
                <div className="border-l-4 border-orange-500 pl-6">
                  <h4 className="font-bold text-gray-900 mb-2">글로벌 확장</h4>
                  <p className="text-gray-600">다국가 대상 글로벌 콘텐츠로 확장 예정</p>
                </div>
              </div>
              
              <div className="bg-orange-50 p-6 rounded-xl">
                <p className="text-sm text-orange-700 font-medium">
                  <i className="ri-information-line mr-2"></i>
                  현재 내부 기획 및 준비 단계에 있으며, 2025년 하반기 본격 서비스 시작 예정
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA 섹션 */}
      <section className="py-20 bg-slate-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">
            퀀텀하이의 서비스가 궁금하신가요?
          </h2>
          <p className="text-xl text-white/80 mb-8 max-w-3xl mx-auto">
            무역, 교육, 콘텐츠 분야의 전문가들이 
            귀하의 비즈니스 성공을 위한 최적의 솔루션을 제안해드립니다
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button className="inline-flex items-center px-8 py-4 bg-orange-500 text-white text-lg font-medium rounded-full hover:bg-orange-600 transition-colors whitespace-nowrap">
              서비스 문의하기
              <i className="ri-arrow-right-line ml-3"></i>
            </button>
            <button className="inline-flex items-center px-8 py-4 border border-white text-white text-lg font-medium rounded-full hover:bg-white hover:text-slate-800 transition-colors whitespace-nowrap">
              자료 다운로드
              <i className="ri-download-line ml-3"></i>
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}